import { getDefaultParameters } from "@/utils/getDefaultParams";
import axios, { type AxiosInstance } from "axios";
import { BaseResponse } from "../types";

const maxBaseUrl = process.env.REACT_APP_MAX_URL;
const autoUrl = process.env.REACT_APP_AUTO_URL;
const rootUrl = process.env.REACT_APP_MARGIN_MAX_URL;

const rootInstanceConfig = {
    baseURL: rootUrl,
    headers: {
        Authorization: "45901FD67DE5B07D0FBFB5BE47DA5F418182DBD440438CA150914E05BE160289",
        "Content-Type": "application/json",
    },
    timeout: 5000,
};

const maxInstanceConfig = {
    baseURL: maxBaseUrl,
    headers: {
        Authorization: "45901FD67DE5B07D0FBFB5BE47DA5F418182DBD440438CA150914E05BE160289",
        "Content-Type": "application/json",
    },
    timeout: 5000,
};

const autoInstanceConfig = {
    baseURL: autoUrl,
    headers: {
        "Content-Type": "application/json",
    },
    timeout: 5000,
};

const testInstanceConfig = {
    baseURL: "https://marginmax.me/api",
    headers: {
        Authorization: "45901FD67DE5B07D0FBFB5BE47DA5F418182DBD440438CA150914E05BE160289",
        "Content-Type": "application/json",
    },
    timeout: 5000,
};
const axiosInstance: AxiosInstance = axios.create(maxInstanceConfig);
const autoAxiosInstance: AxiosInstance = axios.create(autoInstanceConfig);
const testInstance: AxiosInstance = axios.create(testInstanceConfig);
const rootInstance: AxiosInstance = axios.create(rootInstanceConfig);

export const rootApi = {
    get: <T>(url: string, params?: Record<string, unknown>) => {
        const defaultParams = getDefaultParameters();
        const mergedParams = { ...defaultParams, ...params };
        const searchParams = new URLSearchParams(mergedParams);
        const urlWithParams = `${url}?${searchParams?.toString()}`;
        return rootInstance.get<BaseResponse<T>>(urlWithParams, {
            params: {
                t: new Date().getTime(),
            },
        });
    },
    post: <T>(...args: Parameters<typeof axiosInstance.post>) => {
        return rootInstance.post<BaseResponse<T>>(...args);
    },
};

export const api = {
    get: <T>(url: string, params?: Record<string, unknown>) => {
        const defaultParams = getDefaultParameters();
        const mergedParams = { ...defaultParams, ...params };
        const searchParams = new URLSearchParams(mergedParams);
        const urlWithParams = `${url}?${searchParams?.toString()}`;
        return axiosInstance.get<BaseResponse<T>>(urlWithParams, {
            params: {
                t: new Date().getTime(),
            },
        });
    },
    post: <T>(...args: Parameters<typeof axiosInstance.post>) => {
        return axiosInstance.post<BaseResponse<T>>(...args);
    },
};

export const tApi = {
    get: <T>(url: string, params?: Record<string, unknown>) => {
        const defaultParams = getDefaultParameters();
        const mergedParams = { ...defaultParams, ...params };
        const searchParams = new URLSearchParams(mergedParams);
        const urlWithParams = `${url}?${searchParams?.toString()}`;
        return autoAxiosInstance.get<BaseResponse<T>>(urlWithParams, {
            params: {
                t: new Date().getTime(),
            },
        });
    },
    post: <T>(...args: Parameters<typeof autoAxiosInstance.post>) => {
        return autoAxiosInstance.post<BaseResponse<T>>(...args);
    },
};

export const testApi = {
    get: <T>(url: string, params?: Record<string, unknown>) => {
        const defaultParams = getDefaultParameters();
        const mergedParams = { ...defaultParams, ...params };
        const searchParams = new URLSearchParams(mergedParams);
        const urlWithParams = `${url}?${searchParams?.toString()}`;
        return testInstance.get<BaseResponse<T>>(urlWithParams, {
            params: {
                t: new Date().getTime(),
            },
        });
    },
    post: <T>(...args: Parameters<typeof testInstance.post>) => {
        const defaultParams = getDefaultParameters();
        const formData = new FormData();
        formData.append("idx", defaultParams.idx);
        const data: Record<string, any> = args[1] || {};
        Object.keys(data).forEach((key) => {
            formData.append(key, data[key]);
        });
        return testInstance.post<BaseResponse<T>>(args[0], formData, {
            ...args[2],
        });
    },
};
